import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const unsafeDeleteCheckoutAbTest = {
  name: "unsafeDeleteCheckoutAbTest" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: z.null(),
};
